export function debounce(cb: VoidFunction, interval: number, immediate?: boolean): VoidFunction {
	let timeout = 0;

	return function (...args: []): void {
		const context = null;
		const later = function (): void {
			timeout = 0;
			if (!immediate) cb.apply(context, args);
		};

		const callNow = immediate && !timeout;

		clearTimeout(timeout);
		timeout = window.setTimeout(later, interval);
		if (callNow) cb.apply(context, args);
	};
}
